module.exports = __webpack_public_path__ + "img/CM-SL-CA-Volkswagen-Modern.6b84a30c.jpg";